import { Component, OnInit, EventEmitter, Input, Output, ViewChild, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import { Subscription } from 'rxjs';
import { MmtCommonService } from '../../services/mmt-common.service';
import { BlockUI, NgBlockUI } from '../../block-ui';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-system-selector',
  templateUrl: './system-selector.component.html',
  styleUrls: ['./system-selector.component.scss']
})
export class SystemSelectorComponent implements OnInit, OnDestroy {
  @Input() readonly: boolean = false;
  @Output() systemValueSelected: EventEmitter<any> = new EventEmitter<any>();
  selectedSystem: string;
  showSystemComponent: boolean = true;
  roleChanged: boolean = false;
  systemChangeSubscription: Subscription;
  selectedSystemName:string = null;
  reportName: string = null;
  hospitalSystems: any[] = [];
  hospitalSystem :string = null;
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    private commonService: MmtCommonService
  ) { }

  ngOnInit(): void {
    this.systemChangeSubscription = this.commonService.systemChange
      .subscribe(res => {
        if (res) {
          this.commonService.selectedSystem = res;
          if (res) {
            this.selectedSystemName = res;
          }
        }
        this.getHospitalSystems();
      });
  }

  getHospitalSystems() {
    this.commonService.getHospitalSystems()
      .subscribe(res => {
        this.assignListValues(res.data);
      }, error => {
        console.error(error);
      });
  }

  systemNameChanged() {
    this.commonService.systemChange.next(this.selectedSystemName);
    this.systemValueSelected.emit(this.selectedSystemName);
  };
  ngOnDestroy(): void {
    if (this.systemChangeSubscription) {
     this.systemChangeSubscription.unsubscribe();
    }
  }
  private assignListValues(codes) {
    codes.forEach((code) => {
      this.hospitalSystems.push(code.system);
    });
  }

}
